import React from 'react'
import Image, { ImageProps } from 'next/legacy/image'
import styled from 'styled-components'

import { blurImage, cdnLoader } from '@/utils/image'

import shimmerImage from './shimmer-image'

const getPlaceholderImage = (
  src: ImageProps['src'],
  placeholder: Props['placeholder']
) => {
  if (placeholder === 'blur') return blurImage(src)
  if (placeholder === 'shimmer') return shimmerImage(345, 220)
}

const Wrapper = styled.div`
  position: relative;
  filter: none !important;
  width: 100%;
  height: 100%;
  .img-target {
    filter: none !important;
  }
`

type Props = Omit<ImageProps, 'placeholder'> & {
  placeholder: ImageProps['placeholder'] | 'shimmer'
  heightMode?: string | number
}

const cx = (arr: any[]) => arr.filter(arr => !!arr).join(' ')

const hasCustomPlaceholder = (placeholder: Props['placeholder']) =>
  placeholder && placeholder !== 'blur'

const isPlaceholderValid = (
  placeholder: Props['placeholder']
): placeholder is ImageProps['placeholder'] =>
  !hasCustomPlaceholder(placeholder)

interface PlaceholderWrapperProps {
  isCustom?: boolean
  children: JSX.Element
}

const PlaceholderWrapper: React.FC<PlaceholderWrapperProps> = ({
  isCustom,
  children
}) => {
  if (!isCustom) return children
  return <Wrapper>{children}</Wrapper>
}

const CdnImage: React.FC<Props> = ({
  src,
  placeholder,
  alt = '',
  className,
  heightMode,
  ...rest
}) => {
  const custom = hasCustomPlaceholder(placeholder)
  const isStatic = typeof src === 'object'
  return (
    <PlaceholderWrapper isCustom={custom}>
      <Image
        blurDataURL={
          !isStatic || placeholder !== 'blur'
            ? getPlaceholderImage(src, placeholder)
            : undefined
        }
        {...rest}
        src={src}
        alt={alt}
        placeholder={isPlaceholderValid(placeholder) ? placeholder : 'blur'}
        loader={!isStatic ? cdnLoader(heightMode) : undefined}
        className={custom ? cx(['img-target', className]) : className}
      />
    </PlaceholderWrapper>
  )
}

export default CdnImage
